import {all, call, fork, put, takeEvery, delay } from 'bukku/shared/SagaService';
import actions from './actions';
import {get, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.PUBLIC_READ_PRICING_TRANSITION_SUCCESS,
    actions.PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS,
    actions.PUBLIC_READ_PUBLIC_PLANS_SUCCESS,
    actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_SUCCESS,
];
const errorKeys = [
    actions.PUBLIC_READ_PRICING_TRANSITION_ERROR,
    actions.PUBLIC_UPDATE_PRICING_TRANSITION_ERROR,
    actions.PUBLIC_READ_PUBLIC_PLANS_ERROR,
    actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.PUBLIC_READ_PRICING_TRANSITION_SUCCESS:
        case actions.PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS:
        case actions.PUBLIC_READ_PUBLIC_PLANS_SUCCESS:
        case actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_SUCCESS:
        default:
            return null;
    }
};

const useDummyData = false;

function* readPricingTransitionRequest() {
    yield takeEvery(actions.PUBLIC_READ_PRICING_TRANSITION_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* () {
                if (useDummyData) {
                    yield delay(100);
                    yield put({
                        type: actions.PUBLIC_READ_PRICING_TRANSITION_SUCCESS,
                        pricingTransition: {
                            company: {
                                legal_name: "Dummy Company",
                                subdomain: "dummycompany",
                            },
                            current_subscription: {
                                plan: {
                                    id: 1,
                                    name: "Dummy Plan",
                                    billing_cycle: "monthly",
                                    unit_price: 100,
                                },
                                addon_packs: [
                                    {
                                        id: 1,
                                        name: "Dummy Addon Pack",
                                        type: "addon",
                                        unit_price: 20,
                                        quantity: 2,
                                    },
                                ],
                            },
                            new_subscription: {
                                plan: {
                                    id: 2,
                                    name: "New Dummy Plan",
                                    billing_cycle: "yearly",
                                    unit_price: 1200,
                                },
                                addon_packs: [
                                    {
                                        id: 2,
                                        name: "New Dummy Addon Pack",
                                        type: "addon",
                                        unit_price: 30,
                                        quantity: 1,
                                    },
                                ],
                            },
                        },
                    });
                }
                else {
                    if (!action.companyId || !action.hash)
                        throw new Error(t`Company ID and hash are required to read pricing transitions.`);

                    const {companyId, hash} = action;
                    const response = yield call(get, `/pricing_transitions/${companyId}/${hash}`, null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.PUBLIC_READ_PRICING_TRANSITION_SUCCESS,
                        pricingTransition: data.pricing_transition,
                    });
                }
            });
    });
}

function* updatePricingTransitionRequest() {
    yield takeEvery(actions.PUBLIC_UPDATE_PRICING_TRANSITION_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ companyId, hash, request }) {
                if (useDummyData) {
                    yield delay(100);
                    yield put({
                        type: actions.PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS,
                        pricingTransition: {
                            company: {
                                legal_name: "Dummy Company",
                                subdomain: "dummycompany",
                            },
                            current_subscription: {
                                plan: {
                                    id: 1,
                                    name: "Dummy Plan",
                                    billing_cycle: "monthly",
                                    unit_price: 100,
                                },
                                addon_packs: [
                                    {
                                        id: 1,
                                        name: "Dummy Addon Pack",
                                        type: "addon",
                                        unit_price: 20,
                                        quantity: 2,
                                    },
                                ],
                            },
                            new_subscription: {
                                plan: {
                                    id: 2,
                                    name: "New Dummy Plan",
                                    billing_cycle: "yearly",
                                    unit_price: 1200,
                                },
                                addon_packs: [
                                    {
                                        id: 2,
                                        name: "New Dummy Addon Pack",
                                        type: "addon",
                                        unit_price: 30,
                                        quantity: 1,
                                    },
                                ],
                            },
                        },
                    });
                }
                else {
                    if (!companyId || !hash)
                        throw new Error(t`Company ID and hash are required to update pricing transitions.`);

                    const response = yield call(puto, `/pricing_transitions/${companyId}/${hash}`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS,
                        pricingTransition: data.pricing_transition,

                    });
                }
            });
    });
}

function* readPublicPlansRequest() {
    yield takeEvery(actions.PUBLIC_READ_PUBLIC_PLANS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({request}) {
                const response = yield call(get, `/pricing_transitions/plans`, {include_new: true, ...request}, context);
                const data = yield response.data;
                yield put({
                    type: actions.PUBLIC_READ_PUBLIC_PLANS_SUCCESS,
                    plans: data.plans,
                });
            },
        );
    });
}

function* readPublicAddonsPacksRequest() {
    yield takeEvery(actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({include_new}) {
                const response = yield call(get, '/pricing_transitions/addon_packs', { include_new }, context);
                const data = yield response.data;
                yield put({
                    type: actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_SUCCESS,
                    addonPacks: data.addon_packs,
                });
            },
        );
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readPricingTransitionRequest),
        fork(updatePricingTransitionRequest),
        fork(readPublicPlansRequest),
        fork(readPublicAddonsPacksRequest),
    ]);
}
